import {defineStore} from "pinia";
import {ErrorLocationType, ErrorType, OverlayType, PopupType} from "@/utilities/enums/Enums";
import {ColumnStore, Store} from "@bryntum/grid";
import {i18n} from "@/utilities/i18n/config";
import {StartupConfig} from "@/models/StartupConfig";
import router from "@/router";
import User from "@/models/entities/User";
import {useErrorStore} from "@/stores/ErrorStore";
import ServiceConfig from "@/models/entities/ServiceConfig";

export const useGlobalStore = defineStore('GlobalStore', {
    state: () => {
        return {
            refreshIsActive: true,
            currentItems: 0,
            allItems: 0,
            countAfterFilters: 0,
            layout: "simple-layout",
            redirectAfterLogin: null as string|null,
            success: {
                show: false,
                type: OverlayType.temporary,
                text: i18n.global.t("general.success"),
                progressPercentage: "0%"
            },
            modal: {
                show: false,
                validator: {$validate: async ()=><boolean>false},
                resetButton: false,
                title: "Default Popup Title",
                popupType: PopupType.none,
                contentObject: {},
                action: async ()=>{},
                bigMode: false,
            },
            gridStore: null as Store|null,
            gridColumnStore: null as ColumnStore|null,
            user: null as User | null,
            settings: {
                notifications: {
                    durationSuccess: 10000,
                    durationWarning: 10000,
                    durationError: -1,
                    durationInfo: 10000,
                },
                systemConfig: null as StartupConfig|null,
                serviceConfig: null as ServiceConfig|null
            },
            userPreferences: {
                userFilters: [],
                userHiddenColumns: [],
                general: {
                    darkMode: false,
                    userStartPage: null,
                    userLocale: "de",
                }
            },
            tmpPreferences: {
                userFilters: [],
                userHiddenColumns: [],
                general: {
                    darkMode: false,
                    userStartPage: null,
                    userLocale: "de",
                }
            }
        }
    },
    getters: {

    },
    actions: {
        closeModal () {
            this.modal = {
                show: false,
                validator: {$validate: async ()=><boolean>false},
                resetButton: false,
                title: "Default Popup Title",
                popupType: PopupType.none,
                contentObject: {},
                action: async ()=>{},
                bigMode: false
            }
        },
        openPopup ({data, action, resetButton, title, type, big = false}:any) {
            (useErrorStore()).hideError()
            this.closeModal();
            this.modal = {
                validator: {$validate: async ()=><boolean>false},
                show: true,
                title: title,
                resetButton: resetButton,
                popupType: type,
                contentObject: data,
                action: action,
                bigMode: big,
            }
        },
        showSuccess(text:string) {
            this.success.type = OverlayType.temporary;
            this.success.show = true;
            this.success.text = text === undefined ? "DEFAULT OK!" : text;
        },
        showProgress() {
            this.success.type = OverlayType.progress;
            this.success.progressPercentage = "0%"
            this.success.show = true;
        },
        getCallbackUrls():{normal:string, silent:string} {
            const oauthRoutes = router.getRoutes().filter(route=> (route.name as string).toLowerCase().includes("oauth"));
            const silentRoute = oauthRoutes.filter(route => (route.name as string).toLowerCase().includes("silent"))[0];
            const normalRoute = oauthRoutes.filter(route => route != silentRoute)[0];

            return {normal:normalRoute.path, silent:silentRoute.path};
        },
    }
})
